import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { usePageHeader } from '@/core/hooks/usePageHeader';
import usePermission from '@/core/hooks/usePermission';
import DanhSachRoleTable from '@/components/danh-sach-roles-table/DanhSachRoleTable.vue';
import PageContentBase from '@/layout/_shared/PageContentBase.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const { roles } = usePermission();

usePageHeader({
  title: 'Vai trò',
  breadcrumbs: [
    { text: 'Vai trò' },
    { text: 'Danh sách' },
  ],
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(DanhSachRoleTable, { items: _unref(roles) }, null, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})